import { App } from 'antd';
import { useTranslation } from 'react-i18next';
import { useCallback, useEffect, useState } from 'react';
import { useCurrentReservesContext } from '@/context';
import API from '@/services/APIs';
import useMountedState from '../useMountedState';
import useAppStore from '@/store/app.store';

export default function useDailySellManagement() {
  // NEW API
  const { refresh: refetchReserves } = useCurrentReservesContext();
  const { fetchCredit } = useAppStore();

  const [t] = useTranslation(['common', 'reserve']);
  const [loading, setLoading] = useState<boolean>(false);
  const [buyLoading, setBuyLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>('');
  const [buyModal, setBuyModal] = useState<boolean>(false);
  const [forgetModalVisible, setForgetModalVisible] = useState<boolean>(false);
  const [dailySellPrograms, setDailySellPrograms] = useState<
    DailySaleProgramEntity[]
  >([]);

  const isMounted = useMountedState();

  const getDailySellList = useCallback(async () => {
    try {
      setLoading(true);
      const response = await API.reserve.getDailySellProgram();
      if (isMounted()) {
        setLoading(false);
        setError('');
        setDailySellPrograms(response.payload.dailySellPrograms ?? []);
      }
    }
    catch (e) {
      const error = e as HttpErrorResponse;
      if (isMounted()) {
        setLoading(false);
        setError(error.messageFa);
      }
    }
  }, [isMounted]);
  const { message } = App.useApp();

  const buyDailySell = useCallback(
    async (id: number, selectedCount: number) => {      
      try {
        setBuyLoading(true);
        await API.reserve.reserveDailySell(id, selectedCount);
        refetchReserves();

        if (isMounted()) {
          setBuyLoading(false);
          message.success(t('reserve:messages.success-reserve'));
          setBuyModal(false);
          getDailySellList();
          fetchCredit();
        }
      }
      catch (e) {
        const error = e as HttpErrorResponse;
        if (isMounted()) {
          setBuyLoading(false);
          message.error(error.messageFa);
        }
      }
    },
    [getDailySellList, isMounted, refetchReserves, message]
  );

  useEffect(() => {
    // noinspection JSIgnoredPromiseFromCall
    getDailySellList();
  }, [getDailySellList]);

  return {
    loading,
    error,
    dailySellPrograms,
    buyModal,
    setBuyModal,
    buyLoading,
    buyDailySell,
    forgetModalVisible,
    setForgetModalVisible,
    getDailySellList,
  };
}
